import type {Type} from '@packages/systems/wfdl';
import {withMeta} from '@packages/systems/wfdl';
import {dissoc} from '@packages/utilities/key-map';

// Remove top level {meta: {layout: 'None'}} values, these have been added to
// component instances in earlier versions of component overrides. We no longer
// want this value to exist at the top level so migrate away from those.
export const migrateRemoveTopLevelLayoutNone = (dataType: Type) => {
  const meta = dataType.meta;
  if (meta && meta.layout === 'None') {
    return withMeta(dissoc('layout')(meta), dataType);
  }
  return dataType;
};
